(function() {
    const hand = document.querySelector('.footer__hand');

    if (!hand) {
        return;
    }

    let animationHasStarted = false;
    let scrollTimeout;
    let resizeTimeout;

    const sizeQuery = window.matchMedia('(min-width: 600px)');

    const { offsetRight, offsetTop } = getButtonOffset();
    const finalPosition = `translate3D(${offsetRight}px, ${offsetTop}px, 0)`;

    // style after animation has finished
    // is also a fallback for browsers that do not supprt ``animate``
    hand.style.transform = finalPosition;

    if (typeof hand.animate !== 'function' || !sizeQuery.matches) {
        return;
    }

    const pokeButton = () => {
        const { offsetRight, offsetTop } = getButtonOffset();
        const lastButton = document.querySelector('.footer__buttonbox > *:last-child');
        lastButton.classList.add('js-hover');

        setTimeout(() => {
            lastButton.classList.remove('js-hover');
        }, 300);

        hand.animate(
            [
                {
                    transform: `translate3D(${offsetRight}px, ${offsetTop}px, 0)`,
                    offset: 0
                },
                {
                    transform: `translate3D(${offsetRight + 10}px, ${offsetTop}px, 0)`,
                    offset: 0.1
                },
                {
                    transform: `translate3D(${offsetRight}px, ${offsetTop}px, 0)`,
                    offset: 0.2
                },
                {
                    transform: `translate3D(${offsetRight}px, ${offsetTop}px, 0)`,
                    offset: 1
                }
            ],
            {
                easing: 'ease-in-out',
                duration: 1500,
                iterations: Infinity
            }
        );
    };

    const slideFromRight = () => {
        const { offsetTop } = getButtonOffset();
        animationHasStarted = true;
        hand.animate(
            {
                transform: [`translate3D(100%, ${offsetTop}px, 0)`, finalPosition]
            },
            800
        ).onfinish = pokeButton;
    };

    function getButtonOffset() {
        const lastButton = document.querySelector('.footer__buttonbox > *:last-child');

        return {
            offsetRight: hand.clientWidth - (window.innerWidth - lastButton.getBoundingClientRect().right),
            offsetTop: lastButton.offsetTop + lastButton.offsetHeight / 2 - 20
        };
    }

    /**
     * @see: https://stackoverflow.com/a/54630055
     */
    function isInViewPort(element) {
        // Get the bounding client rectangle position in the viewport
        var bounding = element.getBoundingClientRect();

        // Checking part. Here the code checks if it's *fully* visible
        // Edit this part if you just want a partial visibility
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }

    window.addEventListener(
        'scroll',
        function(event) {
            // If there's a timer, cancel it
            if (scrollTimeout) {
                window.cancelAnimationFrame(scrollTimeout);
            }

            // Setup the new requestAnimationFrame()
            scrollTimeout = window.requestAnimationFrame(function() {
                if (
                    isInViewPort(document.querySelector('.footer__buttonbox > *:last-child')) === true &&
                    animationHasStarted === false
                ) {
                    slideFromRight();
                }
            });
        },
        false
    );

    window.addEventListener(
        'resize',
        function(event) {
            if (sizeQuery.matches === false) {
                return;
            }
            // If there's a timer, cancel it
            if (resizeTimeout) {
                window.cancelAnimationFrame(resizeTimeout);
            }

            // Setup the new requestAnimationFrame()
            resizeTimeout = window.requestAnimationFrame(function() {
                slideFromRight();
            });
        },
        false
    );
})();
